import { NgModule } from 'ng-metadata/core';
import { FormPhoneComponent } from './phone.component';
import './phone.scss';

@NgModule({
  declarations: [
    FormPhoneComponent,
  ],
})
export class FormPhoneModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/phone/phone.module.ts